import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/headercomp/Header';
import "./stylings/header.css";
import About from './components/About';
import Contact from './components/Contact';
import Projects from './components/Projects';
import Home from './components/Home';
import ProjectDetail from './components/ProjectDetail';
import Resume from './components/Resume';
import WaterWaveBackground from './components/WaterWaveBackground';
import FloatingContactButton from './components/FloatingContactButton';
import FloatingTopIcons from './components/FloatingTopIcons';
import './stylings/floatingIcons.css';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    document.body.className = darkMode ? 'dark-mode' : 'light-mode';
  }, [darkMode]);

  return (
    <Router>
      <div className={`App ${darkMode ? 'dark-mode' : 'light-mode'}`}>
        <WaterWaveBackground darkMode={darkMode} />
        <Header darkMode={darkMode} setDarkMode={setDarkMode} />
        <FloatingTopIcons darkMode={darkMode} setDarkMode={setDarkMode} />
        <FloatingContactButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resume" element={<Resume />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
